import angular from 'angular';
import viewComfortDropdown from './viewComfortDropdown';
import './style.scss';

export default angular
  .module('components.viewComfortDropdown', [])
  .component('viewComfortDropdown', viewComfortDropdown).name;
